export type ReferralDiscountRow = {
  id?: string
  referred_customer_id: string
  referred_customer_name?: string
  referred_internet_id?: string
  base_discount_amount: number
  applied_discount_amount: number
  eligibility_status: string
  source_note?: string | null
  removed?: boolean
}

export function referralStatusLabel(status: string): string {
  switch (status) {
    case "eligible":
      return "Eligible"
    case "blocked_unpaid_history":
      return "Blocked — prior unpaid invoice"
    case "blocked_not_active_yet":
      return "Blocked — starts next month"
    case "removed_manual":
      return "Removed"
    default:
      return status.replace(/_/g, " ")
  }
}

export function referralStatusTone(status: string): string {
  switch (status) {
    case "eligible":
      return "text-emerald-700 bg-emerald-50 border-emerald-100"
    case "removed_manual":
      return "text-slate-500 bg-slate-50 border-slate-100"
    default:
      return "text-amber-700 bg-amber-50 border-amber-100"
  }
}

export function hasVisibleReferralDiscounts(rows?: ReferralDiscountRow[] | null): boolean {
  if (!rows?.length) return false
  return rows.some((row) => row.eligibility_status !== "removed_manual")
}

export function visibleReferralDiscountTotal(rows?: ReferralDiscountRow[] | null): number {
  if (!rows?.length) return 0
  return rows.reduce((sum, row) => {
    if (row.eligibility_status !== "eligible") return sum
    return sum + (Number(row.applied_discount_amount) || 0)
  }, 0)
}
